import { PageLayout } from "@components/ui/PageLayout"
import { contactPageQueryOptions } from "@data/public-page-data-query"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { isSupportedLocale } from "@utils/locale"
import { localizedRouteHead } from "@utils/route-head"
import { getLocalizedCareers } from "@utils/site-data"
import { ContactPage } from "./-ContactPage"

export const Route = createFileRoute("/$locale/contact/$slug")({
  beforeLoad: ({ params }) => {
    if (!isSupportedLocale(params.locale)) throw redirect({ to: "/404" })
  },
  loader: async ({ context, params }) => {
    const locale = params.locale as "en" | "ja"
    const data = await context.queryClient.ensureQueryData(contactPageQueryOptions(locale))
    const position = getLocalizedCareers(data, locale).find((item) => item.slug?.current === params.slug)
    if (!position) throw redirect({ href: `/${locale}/contact` })
    return { data, position }
  },
  head: ({ params, loaderData }) => {
    const locale = params.locale as "en" | "ja"
    return localizedRouteHead({
      locale,
      page: "contact",
      path: `/${locale}/contact/${params.slug}`,
      title: loaderData?.position?.title ? `${loaderData.position.title} | PLAYBRAIN Inc.` : undefined,
      robots: "noindex,nofollow",
    })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { data, position } = Route.useLoaderData()
  return (
    <PageLayout>
      <ContactPage
        selectedPosition={position?.title ?? ""}
        isSubPage
        data={data}
      />
    </PageLayout>
  )
}
